import Vue from 'vue';
import { Amplify } from '@aws-amplify/core/lib-esm/Amplify';
import { AWSCognitoConfigs } from './cognitoConfig';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import Vue2TouchEvents from 'vue2-touch-events';
import './assets/scss/main.scss';

Amplify.configure(AWSCognitoConfigs());

Vue.config.productionTip = false;
Vue.use(Vue2TouchEvents);

export const bus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
